export const trackEvent = (eventName: string, properties: BaseTracking) => {
    let trackFn = null;

    if (typeof window !== 'undefined' && window.analytics) {
        trackFn = window.analytics.track;
    }

    const trackParams = window.trackParams || {};

    if (!trackFn) {
        return;
    }

    trackFn(eventName, {
        ...trackParams,
        ...properties,
    });
};
